import createModel from 'utils/model'
import {
    getGroupList,
    getGroupOwnerList,
    editGroupInfo,
    downloadTemplate,
    importGroupLink,
    communityQrcode,
    tasks,
    exportListData,
} from 'crm/services/group-list'
import _ from 'lodash'

export default createModel({
    namespace: 'crm_groupList',

    state: {
        tableList: {},
        communityQrcodeList: {},
    },

    effects: {
        *tasks({payload}, {call}) {
            return yield call(tasks, payload)
        },
        *downloadTemplate({payload}, {call}) {
            return yield call(downloadTemplate, payload)
        },
        *importGroupLink({payload}, {call}) {
            return yield call(importGroupLink, payload)
        },
        *communityQrcode(xx, {select, put, call}) {
            const {communityQrcodeList} = yield select(({crm_groupList}) => crm_groupList)

            const newParams = {
                offset:
                    communityQrcodeList.pagination.pageSize *
                    (communityQrcodeList.pagination.current - 1),
                limit: communityQrcodeList.pagination.pageSize,
                ...communityQrcodeList.params,
            }

            const res = yield call(communityQrcode, newParams)

            yield put({
                type: 'immerCb',
                payload: (draft) => {
                    draft.communityQrcodeList.dataSource = res.data
                    draft.communityQrcodeList.pagination.total = _.get(
                        res,
                        'pagination.rows_found',
                        0,
                    )
                },
            })
        },
        *getGroupList(xx, {select, put, call}) {
            const {tableList} = yield select(({crm_groupList}) => crm_groupList)

            const newParams = {
                offset: tableList.pagination.pageSize * (tableList.pagination.current - 1),
                limit: tableList.pagination.pageSize,
                ...tableList.params,
            }

            const res = yield call(getGroupList, {body: newParams})

            yield put({
                type: 'immerCb',
                payload: (draft) => {
                    draft.tableList.dataSource = res.data
                    draft.tableList.pagination.total = _.get(res, 'pagination.rows_found', 0)
                },
            })
        },

        *editGroupInfo({payload}, {call}) {
            return yield call(editGroupInfo, payload)
        },
        *getGroupOwnerList({payload}, {call}) {
            return yield call(getGroupOwnerList, payload)
        },
        *exportListData({payload}, {call}) {
            return yield call(exportListData, payload)
        },
    },
})
